/**
 * Decides whether there is an announcement to show, and in which form.
 *
 * Mounted once in `App`, above the routes — not in `SiteLayout`, because
 * the landing page builds its own layout and is exactly where someone
 * arrives after signing in.
 *
 * Renders nothing at all when there is no live announcement, when the
 * acknowledgement lookup fails, or when nobody is signed in.
 */

import { AnnouncementBanner } from './AnnouncementBanner';
import { AnnouncementModal } from './AnnouncementModal';
import { useCurrentAnnouncement } from './useCurrentAnnouncement';

export function AnnouncementHost() {
  const { announcement, index, total, presentation, advance, close, goBack, canGoBack } =
    useCurrentAnnouncement();
  if (!announcement) return null;

  // One surface for the whole run, so several unseen announcements are
  // one interruption rather than several. `presentation` is decided
  // across the run, not per page — see the hook.
  const paging = {
    index,
    total,
    onNext: () => advance('acknowledged'),
    onBack: goBack,
    canGoBack,
  };

  return presentation === 'modal' ? (
    <AnnouncementModal announcement={announcement} onDismiss={close} {...paging} />
  ) : (
    <AnnouncementBanner announcement={announcement} onDismiss={close} {...paging} />
  );
}
